export const PersonsActionTypes = {
  API_RESPONSE_SUCCESS: '@@persons/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@persons/API_RESPONSE_ERROR',

  GET_PERSON: '@@persons/GET_PERSON',
  LIST_PERSONS: '@@persons/LIST_PERSONS',
  ADD_PERSON: '@@persons/ADD_PERSON',
  UPDATE_PERSON: '@@persons/UPDATE_PERSON',
  DELETE_PERSON: '@@persons/DELETE_PERSON',

  RESET: '@@persons/RESET'
}
